import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import { CartItem } from 'graphql/types/CartItem';

export const useQueryReplacementAvailableChoiceWithSet = (
  options?: QueryHookOptions<
    ReplacementAvailableChoiceWithSetData,
    ReplacementAvailableChoiceWithSetVariables
  >,
) =>
  useQuery<
    ReplacementAvailableChoiceWithSetData,
    ReplacementAvailableChoiceWithSetVariables
  >(REPLACEMENT_AVAILABLE_CHOICE_WITH_SET, options);

export const REPLACEMENT_AVAILABLE_CHOICE_WITH_SET = gql`
  query replacementAvailableChoiceWithSet($section: String) {
    replacementAvailableChoiceWithSet {
      id
      quantity
      monitored(section: $section)
      commodity {
        itemCode
        description
        stockStatus
        price
        currency
        sellable
        stocks {
          stock
          source
          id
          location
          status
        }
        replacements {
          setNumber
          quantity
          commodity {
            itemCode
            id
            price
            currency
            sellable
            description
          }
          items {
            id
            quantity
            commodity {
              itemCode
              id
              price
              currency
              sellable
              description
            }
            replacement {
              remarks
            }
          }
          id
          createdAt
          updatedAt
        }
        validate {
          setNumber
          quantity
          commodity
          items {
            id
            commodity {
              itemCode
              id
              description
            }
          }

          id
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export type ReplacementAvailableChoiceWithSetVariables = {
  section: string;
};

export type ReplacementAvailableChoiceWithSetData = {
  replacementAvailableChoiceWithSet: CartItem[];
};
